export default __webpack_public_path__ + "ru.c0d15cf1.png";